import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./AddGlobalAdminModal.module.css";
import { useState } from "react";

/**
 *
 * Modal used for confirmation of removing an admin on the admins tab of the groups page.
 *
 */

export function AddGlobalAdminModal({ isOpen, onClose, onClick }) {
  const [firstNameInput, setFirstNameInput] = useState("");
  const [lastNameInput, setLastNameInput] = useState("");
  const [emailInput, setEmailInput] = useState("");

  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.containerContainer}>
      <div className={styles.modalBackground} onClick={onClose} />
      <div className={styles.container}>
        <div className={styles.bold}>ADD GLOBAL ADMIN</div>
        <div className={styles.hr} />

        <div>
          Adding a global admin will give them admin permissions for all groups.
        </div>

        <div className={styles.inputContainer}>
          <div className={classNames(styles.bold, styles.lineHeight)}>
            First Name:
          </div>
          <input
            type="text"
            placeholder="Click to type"
            className={classNames(styles.inputField, styles.namesInput)}
            onChange={(e) => setFirstNameInput(e.target.value)}
          />
          <div className={classNames(styles.bold, styles.lineHeight)}>
            Last Name:
          </div>
          <input
            type="text"
            placeholder="Click to type"
            className={classNames(styles.inputField, styles.namesInput)}
            onChange={(e) => setLastNameInput(e.target.value)}
          />
          <div className={classNames(styles.bold, styles.lineHeight)}>
            Email Address:
          </div>
          <input
            type="text"
            placeholder="Click to type"
            className={styles.inputField}
            onChange={(e) => setEmailInput(e.target.value)}
          />
        </div>

        <div className={styles.buttonContainer}>
          <button
            className={classNames(styles.button, styles.cancelBtn)}
            onClick={onClose}
          >
            CANCEL
          </button>
          <button
            className={styles.button}
            onClick={() =>
              onClick({
                name: firstNameInput + " " + lastNameInput,
                email: emailInput,
              })
            }
          >
            ADD ADMIN
          </button>
        </div>
      </div>
    </div>
  );
}

AddGlobalAdminModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  onSearch: PropTypes.func,
};
